import _ from 'lodash';
import { useEditComments } from '@/presentation/pages/detail/basic/hooks/useEditComments';
import getUserDisplayInfo from '@cores/utils/getUserDisplayInfo';
import PatSnapUserAvatar from '@/presentation/components/PatSnapUserAvatar.vue';
export const name = 'COMMENT.render';
const LIMIT = 3;
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const cellValue = _.get(row, prop);
    const commentsList = [];
    let moreBtn = null;
    if (cellValue) {
        let count = 0;
        for (const comment of cellValue.comments || []) {
            if (count >= LIMIT)
                break;
            commentsList.push(<div class="cell-comment-item flex items-center">
                    <PatSnapUserAvatar class="mr-1 size-4 text-[10px]" userId={comment.comment_by_info.user_id}/>
                    <span class="cell-comment-by">
                        {`${getUserDisplayInfo(comment.comment_by_info)}: `}
                    </span>
                    <span class="cell-comment-text">
                        {(comment.comment_text || '').replace(/\n/g, ' ')}
                    </span>
                </div>);
            count++;
        }
        const hideCount = cellValue.comment_count - LIMIT;
        if (hideCount > 0) {
            moreBtn = <div class="cell-comment-number" onClick={() => {
                    useEditComments({ patent: row });
                }}>
                {`+${hideCount}`}
            </div>;
        }
    }
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {commentsList}
            {moreBtn}
        </div>,
    ];
}
function exportMethod() {
    return '';
}
export default {
    renderDefault,
    exportMethod,
};
